(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('PrmLoginService', [
        '$q',
        'PrmLoginServiceTs',
        PrmLoginService
    ]);

    function PrmLoginService(
        $q,
        PrmLoginServiceTs
    ) {
        return {
            login: login,
        };

        function login(username, password, userId, clientFeatures) {
            var promise = PrmLoginServiceTs.login(username, password, userId, clientFeatures).toPromise();
            return $q.when(promise);
        }
    }
})();